<template>
  <div class="card" v-show="currentCardId == 'en-profile'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>ウェブサイト・役職</h2>
        <p>PDFヘッダーに表示される補足情報を入力してください（任意）</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">ウェブサイト</div>
            <div class="item-body">
              <el-input
                class="input-lg"
                placeholder="https://example.com"
                title="Website"
                v-model="formatData.website"
                type="url"
              />
              <p class="addition">
                ポートフォリオサイトや LinkedIn などの URL を入力してください
              </p>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">最近の役職</div>
            <div class="item-body">
              <el-input
                class="input-lg"
                placeholder="Senior Software Engineer"
                title="Recent Position"
                v-model="formatData.recentPosition"
              />
              <p class="addition">PDF ヘッダーに表示されます（任意）</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useEnglishResumeFormatData } from '@/composables/format-edit/useEnglishResumeFormatData'

defineProps<{
  currentCardId?: string
}>()

const formatData = useEnglishResumeFormatData()
</script>

<style scoped lang="scss">
.addition {
  font-size: 0.75rem;
  margin: 0.5rem 0;
  color: #666;
}
</style>
